import { getQueryStringParameter, clearInputField } from '../../../helpers';
import { autoNumericFormatter } from '../../../autoNumericFormatter'

$(() => {
  const $form = $('form#natural-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'non_professional_investor_experience') {
    return;
  }

  autoNumericFormatter();

  const $privateEquityKnowledgeWarning = $('#private_equity_knowledge_warning', $form);

  $('#users_profile_natural_private_equity_knowledge_bad', $form).on('click', (_e) => {
    $privateEquityKnowledgeWarning.removeClass('d-none');
  });

  $('#users_profile_natural_private_equity_knowledge_medium', $form).on('click', (_e) => {
    $privateEquityKnowledgeWarning.addClass('d-none');
  });

  $('#users_profile_natural_private_equity_knowledge_good', $form).on('click', (_e) => {
    $privateEquityKnowledgeWarning.addClass('d-none');
  });

  const $privateEquityInterestWarning = $('#private_equity_interest_warning', $form);

  $('#users_profile_natural_private_equity_interest_low', $form).on('click', (_e) => {
    $privateEquityInterestWarning.removeClass('d-none');
  });

  $('#users_profile_natural_private_equity_interest_moderate', $form).on('click', (_e) => {
    $privateEquityInterestWarning.addClass('d-none');
  });

  $('#users_profile_natural_private_equity_interest_high', $form).on('click', (_e) => {
    $privateEquityInterestWarning.addClass('d-none');
  });

  const $privateEquityExperienceFields = $('#private_equity_experience_fields', $form);

  $('#users_profile_natural_private_equity_experience_frequent', $form).on('click', (_e) => {
    $privateEquityExperienceFields.removeClass('d-none');

  });

  $('#users_profile_natural_private_equity_experience_occasional', $form).on('click', (_e) => {
    $privateEquityExperienceFields.removeClass('d-none');
  });

  $('#users_profile_natural_private_equity_experience_rare', $form).on('click', (_e) => {
    $privateEquityExperienceFields.addClass('d-none');
    $('input', $privateEquityExperienceFields).each((_, selectElement) => {
      clearInputField(selectElement);
    });
  });
});
